import QuoraPixel from './QuoraPixel';

export default QuoraPixel;
